import { Routes, Route, Outlet, useParams } from 'react-router-dom';
import JoinPage from './pages/JoinPage';
import LoginPage from './pages/LoginPage';
import WritePage from './pages/WritePage';
import StoryCompletedPage from './pages/StoryCompletedPage';
import ComicViewerPage from './pages/ComicViewerPage';
import ComicExplorerPage from './pages/ComicExplorerPage';
import MyLibraryPage from './pages/MyLibraryPage';
import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import AccountRemovePage from './pages/AccountRemovePage';
import SupportPage from './pages/SupportPage';
import { LegacyLocaleRedirect, useSyncLocaleFromUrl } from './hooks/useUILocale';
import { isSupportedUILocale } from './locale';

const LocaleLayout: React.FC = () => {
  useSyncLocaleFromUrl();
  const { uiLocale } = useParams<{ uiLocale: string }>();
  if (!isSupportedUILocale(uiLocale)) {
    return <LegacyLocaleRedirect />;
  }
  return <Outlet />;
};

export const AppRoutes: React.FC = () => (
  <Routes>
    <Route path=":uiLocale" element={<LocaleLayout />}>
      <Route index element={<LandingPage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="join/:code" element={<JoinPage />} />
      <Route path="story/:id/write" element={<WritePage />} />
      <Route path="story/:id/completed" element={<StoryCompletedPage />} />
      <Route path="comic/s/:shareCode" element={<ComicViewerPage />} />
      <Route path="explore" element={<ComicExplorerPage />} />
      <Route path="explore/:contentLang" element={<ComicExplorerPage />} />
      <Route path="library" element={<MyLibraryPage />} />
      <Route path="privacy" element={<PrivacyPage />} />
      <Route path="terms" element={<TermsPage />} />
      <Route path="support" element={<SupportPage />} />
      <Route path="about" element={<SupportPage />} />
      <Route path="privacy/remove" element={<AccountRemovePage />} />
    </Route>
    <Route path="*" element={<LegacyLocaleRedirect />} />
  </Routes>
);
